import { Controller } from "stimulus"
import { showTarget, hideTarget } from '../helpers/visibility'

export default class extends Controller {
  static targets = ["checkbox", "scheduledPaymentIdField", "bulkUpdateControls"]

  connect() {
    this.update()
  }

  update() {
    if(this.hasScheduledPaymentIdFieldTarget) {
      const checked = this.checkboxTargets.filter(c => c.checked)
      const scheduledPaymentIds = checked.map(checkbox => checkbox.value)
      this.scheduledPaymentIdFieldTarget.value = scheduledPaymentIds.join(",")

      if(scheduledPaymentIds.length) {
        showTarget(this.bulkUpdateControlsTarget)
      }
      else {
        hideTarget(this.bulkUpdateControlsTarget)
      }
    }
    else {
      this.hideAllCheckboxes()
    }
  }

  hideAllCheckboxes() {
    hideTarget(this.checkboxTargets)
  }
}

